import { render, staticRenderFns } from "./Preparacao.vue?vue&type=template&id=2cc55b4d"
import script from "./Preparacao.vue?vue&type=script&lang=js"
export * from "./Preparacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports